/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import MultipleCashbackRepository from '../../repositories/Admin/MultipleCashbackRepository';
import { createRestSlice } from '../../utils/RestSlice';

const multipleCashbackRestSlice = createRestSlice({
  resource: 'multipleCashback',
  repository: MultipleCashbackRepository,
  slices: ['createMultipleCashback'],
});

const initialState = {
  ...multipleCashbackRestSlice.initialState,
};

const multipleCashbackSlice = createSlice({
  name: 'multipleCashback',
  initialState,
  reducers: {
    ...multipleCashbackRestSlice.reducers,
  },
});
export default multipleCashbackSlice.reducer;

export const multipleCashbackRestHooks = multipleCashbackRestSlice.hooks(
  multipleCashbackSlice,
  ['admin', 'MultipleCashbackSlice']
);
